module.exports = __webpack_public_path__ + "5de70313971f9a325f9d1528f837b359.pdf";